<p-card class="p-card container">
  <div class="flex justify-content-between">
    <h3 i18n>Informations importantes</h3>
    <p class="text-xl text-800" i18n
      >Date de la proposition : <strong>{{ profileInfo.createdAt | date: 'longDate' }}</strong></p
    >
  </div>

  <div class="flex gap-4">
    <em-protection-summary
      class="w-full"
      [protectionSummary]="profileInfo.protectionSummary"></em-protection-summary>
    <div class="flex layout__inner-card w-full justify-content-center align-items-center">
      <div class="align-content-center">
        @if (profileInfo.hasMIBReplies) {
          <a routerLink="mib" class="p-button font-bold pb-0.5" i18n
            ><span class="pi pi-file-pdf pb-0.5"></span>&nbsp;Ouvrir le rapport MIB
          </a>
        } @else {
          <p i18n class="font-italic">Aucun rapport MIB correspondant</p>
        }
      </div>
    </div>
  </div>
</p-card>
